@if (layout() === "default") {
    <div
        class="flex overflow-hidden overflow-x-hidden relative flex-col w-screen h-dvh"
    >
        <app-header class="safe-top z-[100]" />
        <app-menus [menus]="menus()" />

        <!-- router outlet 경로 -->
        <div
            #layoutRef
            (scroll)="onLayoutScroll()"
            class="layout flex overflow-y-auto flex-col bg-white size-full basis-full grow-0"
        >
            <app-guard />
            <div class="flex items-end w-full h-full">
                <app-footer class="hidden w-full xl:block" />
            </div>
        </div>

        <div class="block z-10 w-full xl:hidden">
            <app-bottom-sheet [menus]="menus()" />
        </div>

        <app-center-completeness
            class="fixed bottom-20 lg:bottom-5 right-10 z-[999]"
        />
    </div>
} @else {
    <div
        class="flex overflow-hidden overflow-x-hidden relative flex-col w-screen h-full min-h-screen"
    >
        <div
            #layoutRef
            (scroll)="onLayoutScroll()"
            class="container flex overflow-y-auto flex-col bg-white size-full basis-full grow-0"
        >
            <router-outlet />
        </div>
    </div>
}
